__webpack_require__.p = "https://lexy-language.github.io/lexy-editor/";